import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { seasoningTypes } from '../../data/withdraw';
import { SeasoningForm } from '../../types/withdraw';
import { inputClasses } from '../../utils/styles';
import { FormField } from '../ui/FormField';
import { SuffixInput } from '../ui/SuffixInput';
interface SeasoningReasonFieldsProps {
  form: SeasoningForm;
  onChange: (patch: Partial<SeasoningForm>) => void;
}
export function SeasoningReasonFields({
  form,
  onChange
}: SeasoningReasonFieldsProps) {
  switch (form.reason) {
    case 'Rate Watch':
      {
        const cur = parseFloat(form.currentRate);
        const tgt = parseFloat(form.targetRate);
        const both = !Number.isNaN(cur) && !Number.isNaN(tgt);
        return <div className="grid gap-4 sm:grid-cols-2" data-id="element-184" data-mp="mfg34xtqkhkh">
          <FormField label="Current rate" htmlFor="current-rate" required data-id="element-185" data-mp="2crn75r1ruusb">
            <SuffixInput id="current-rate" value={form.currentRate} onChange={v => onChange({
              currentRate: v
            })} suffix="%" placeholder="7.125" step={0.125} data-id="element-186" data-mp="2cpj3na7sbxsk" />
          </FormField>
          <FormField label="Target rate" htmlFor="target-rate" required hint={both ? tgt < cur ? <span className="font-medium text-primary-700" data-id="element-188" data-mp="pa9g6pgwzssd">Reactivate when rates drop {(cur - tgt).toFixed(3)}%</span> : <span className="font-medium text-coral-700" data-id="element-189" data-mp="3sr9fb0su8t3z">Target should be below the current rate</span> : undefined} data-id="element-187" data-mp="fj6a1994onm8">
            <SuffixInput id="target-rate" value={form.targetRate} onChange={v => onChange({
              targetRate: v
            })} suffix="%" placeholder="6.250" step={0.125} data-id="element-190" data-mp="3nuiy2a5arrgz" />
          </FormField>
        </div>;
      }
    case 'Credit Repair':
      {
        const cur = parseInt(form.currentScore, 10);
        const tgt = parseInt(form.targetScore, 10);
        const both = !Number.isNaN(cur) && !Number.isNaN(tgt);
        return <div className="grid gap-4 sm:grid-cols-2" data-id="element-191" data-mp="1k3lejf2d16l6">
          <FormField label="Current credit score" htmlFor="current-score" required data-id="element-192" data-mp="1k2s3w30a5wxr">
            <SuffixInput id="current-score" value={form.currentScore} onChange={v => onChange({
              currentScore: v
            })} placeholder="618" min={300} max={850} data-id="element-193" data-mp="1p1mwtxryp1vl" />
          </FormField>
          <FormField label="Target score" htmlFor="target-score" required hint={both && tgt > cur ? <span className="font-medium text-primary-700" data-id="element-195" data-mp="11en4t8ukj05a">+{tgt - cur} points to go</span> : 'Between 300 and 850'} data-id="element-194" data-mp="1z1dsi2s9dmx9">
            <SuffixInput id="target-score" value={form.targetScore} onChange={v => onChange({
              targetScore: v
            })} placeholder="660" min={300} max={850} data-id="element-196" data-mp="16a2ctk5wa1ts" />
          </FormField>
        </div>;
      }
    case 'Forbearance':
    case 'Loan Modification':
      return <FormField label="Expected end date" htmlFor="expected-end" required className="sm:max-w-[280px]" data-id="element-197" data-mp="im2qqxjj2zlj">
          <input id="expected-end" type="date" value={form.expectedEndDate} onChange={e => onChange({
          expectedEndDate: e.target.value
        })} className={inputClasses} data-id="element-198" data-mp="njuinrk6alpq" />
        </FormField>;
    case 'Loan Seasoning':
      return <div className="grid gap-4 sm:grid-cols-[1.4fr_1fr]" data-id="element-199" data-mp="2rxd88u4gu1yv">
          <FormField label="Seasoning type" htmlFor="seasoning-type" required data-id="element-200" data-mp="2mv4dbs818pu4">
            <div className="relative" data-id="element-201" data-mp="2hxmdqsfwnmys">
              <select id="seasoning-type" value={form.seasoningType} onChange={e => onChange({
              seasoningType: e.target.value
            })} className={`${inputClasses} appearance-none pr-10 ${form.seasoningType ? '' : 'text-slate-400'}`} data-id="element-202" data-mp="2hynnmtl6q3ex">
                <option value="" disabled data-id="element-203" data-mp="247iveck5cdem">
                  Select a type
                </option>
                {seasoningTypes.map(t => <option key={t} value={t} className="text-slate-900" data-id="element-204" data-mp="1u706329tc4pb">
                    {t}
                  </option>)}
              </select>
              <ChevronDownIcon className="pointer-events-none absolute right-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" aria-hidden="true" data-id="element-205" data-mp="3ubuhjdt4wl5h" />
            </div>
          </FormField>
          <FormField label="Eligible date" htmlFor="eligible-date" required data-id="element-206" data-mp="3kjok3ok45biw">
            <input id="eligible-date" type="date" value={form.eligibleDate} onChange={e => onChange({
            eligibleDate: e.target.value
          })} className={inputClasses} data-id="element-207" data-mp="3phq90q48052a" />
          </FormField>
        </div>;
    default:
      return null;
  }
}